import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { X, MessageCircle } from "lucide-react";
import { waMenuLink, scrollToId } from "@/data/site";

const KEY = "sapore-welcome-seen";

export default function WelcomePopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(KEY)) return;
    const t = setTimeout(() => setOpen(true), 1600);
    return () => clearTimeout(t);
  }, []);

  const close = () => {
    sessionStorage.setItem(KEY, "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="fixed inset-0 z-[60] bg-charred/60 backdrop-blur-sm grid place-items-center px-6"
      onClick={close}
      data-testid="welcome-popup"
    >
      <motion.div
        initial={{ scale: 0.92, y: 24 }}
        animate={{ scale: 1, y: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
        className="relative bg-cream rounded-lg max-w-md w-full p-8 md:p-10 text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={close} data-testid="welcome-close-btn" aria-label="Chiudi"
          className="absolute top-4 right-4 text-charred/50 hover:text-charred transition-colors">
          <X size={20} />
        </button>
        <p className="text-xs uppercase tracking-[0.25em] text-terracotta font-medium">Benvenuto da SAPORÉ</p>
        <h3 className="mt-3 font-serif text-3xl md:text-4xl text-charred leading-tight">Scopri cosa abbiamo preparato oggi</h3>
        <p className="mt-3 text-charred/70 text-sm">Contattaci per ricevere il menù del giorno e prenotare il tuo ordine.</p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => { close(); setTimeout(() => scrollToId("piatti-del-giorno"), 150); }}
            data-testid="welcome-menu-btn"
            className="rounded-full bg-terracotta text-cream px-6 py-2.5 text-sm font-semibold hover:bg-terracotta-dark transition-colors"
          >
            Guarda il menù
          </button>
          <a
            href={waMenuLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="welcome-whatsapp-btn"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-charred/30 text-charred px-6 py-2.5 text-sm font-semibold hover:bg-charred hover:text-cream transition-colors"
          >
            <MessageCircle size={15} /> Scrivici su WhatsApp
          </a>
        </div>
      </motion.div>
    </motion.div>
  );
}
